// extracted by mini-css-extract-plugin
export var closeButton = "_p-0";